import { render, staticRenderFns } from "./PatientTransfer.vue?vue&type=template&id=651f4f3e&"
import script from "./PatientTransfer.vue?vue&type=script&lang=tsx&"
export * from "./PatientTransfer.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports